// 1. React and DOM imports

// 2. External libraries
import { useQuery } from '@tanstack/react-query';

// 3. Internal components

// 4. Type imports
import type { UseQueryResult } from '@tanstack/react-query';
import type { NotificationListResponse } from '~/generated/api/model';

// 5. Custom hooks and utilities
import { listNotificationsV1NotificationsGet } from '~/generated/api/notifications/notifications';
import { queryKeys } from './queryKeys';

export function useUnreadCountQuery(): UseQueryResult<number, Error> {
  return useQuery({
    queryKey: queryKeys.notifications.count,
    queryFn: async () => {
      const response = await listNotificationsV1NotificationsGet({
        unread_only: true,
        limit: 1,
      });
      return response.unreadCount;
    },
  });
}

export function useNotificationsQuery(options?: {
  unreadOnly?: boolean;
  limit?: number;
}): UseQueryResult<NotificationListResponse, Error> {
  return useQuery({
    queryKey: queryKeys.notifications.list(options?.unreadOnly, options?.limit),
    queryFn: async () => {
      return listNotificationsV1NotificationsGet({
        unread_only: options?.unreadOnly ?? false,
        limit: options?.limit ?? 50,
      });
    },
  });
}
